export default function recaptcha(action) {
  return new Promise((resolve) => {
    // eslint-disable-next-line no-undef
    grecaptcha.ready(() => {
      resolve();
    });
    // eslint-disable-next-line no-undef
  }).then(() => grecaptcha.execute('6LecavwZAAAAALUZKg8BduxvE65I88GRM1J-qRLS', { action }));
}
